import React from 'react';

import { useDeferredLoading } from 'src/hooks/useDeferredLoading';
import { SkeletonBar } from 'src/components/TableNew';

import { DataTableSkeletonCell } from './styled';

type ManagementTableSkeletonProps = {
  loading: boolean;
  hasContent: boolean;
  columns: number;
  rows?: number;
};

export const ManagementTableSkeleton: React.FC<ManagementTableSkeletonProps> = ({
  loading,
  hasContent,
  columns,
  rows = 8,
}) => {
  const showLoading = useDeferredLoading(loading, hasContent);
  if (!showLoading || hasContent) return null;

  const widths = ['58%', '82%', '44%', '68%', '36%', '74%'];

  return (
    <>
      {Array.from({ length: rows }, (_, rowIndex) => (
        <tr key={`skeleton-${rowIndex}`} className="skeleton-row" aria-hidden>
          {Array.from({ length: columns }, (_, colIndex) => (
            <DataTableSkeletonCell key={colIndex}>
              <SkeletonBar $width={widths[(rowIndex + colIndex) % widths.length]} />
            </DataTableSkeletonCell>
          ))}
        </tr>
      ))}
    </>
  );
};
